import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import './photo.css'

const fileTypes = ["JPG", "PNG", "GIF"];

function DragAndDropImage(props) {
  const [file, setFile] = useState(null);
  const handleChange = (file) => {
    setFile(file);
    props.setPhoto(file)
  };
  const customButtonStyleNew = {
    width: '200px',
    height: '22px',
    display: 'flex',
    justifyContent: 'center', alignItems: 'center', alignContent: 'center',
    backgroundColor: "#4CAF50", // Set your desired background color
    color: "white", // Set your desired text color
    padding: "10px 20px", // Set your desired padding
    border: "none", // Set your desired border
    borderRadius: "5px", // Set your desired border radius
    cursor: "pointer", // Set cursor style
  };

  return (
    <>
      <div style={{ width: '86%', height: 175, border: '2px dashed #707070', borderRadius: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 100, marginLeft: 20 }}>
        <FileUploader
          handleChange={handleChange}
          name="file"
          types={fileTypes}
          style={{ width: '100%', height: '100%' }}
        >
          <div style={{ width: '100%', height: '40%', display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
            <div style={{ width: '50%', height: '40%', }}>
              <p style={{ font: 'normal normal normal 20px/26px Roboto', textAlign: 'center' }}>Drop Photo Here or</p>
            </div>
          </div>
          <div style={{ width: '100%', height: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
            <div style={customButtonStyleNew}>Select File</div>
          </div>
        </FileUploader>
      </div>
    </>
  );
}

export default DragAndDropImage;